import React from "react";
import "./style.css";

export const AppButton = ({
  text,
  size,
  onClick,
}: {
  text: string;
  size?: "long" | "default";
  onClick: () => void;
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={size === "long" ? "appButton long" : "appButton"}
    >
      <span>{text}</span>
    </button>
  );
};
